var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeSportLogoPrimaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 604.36 153.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#db5c2c;}.cls-2{fill:#696c6d;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 82.59,
    y1: 12.21,
    x2: 40.43,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f37021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ee6922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e25525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#cd352a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a91d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911c27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 62.89,
    y1: 143.51,
    x2: 86.61,
    y2: 55.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc8c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#bdb9b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#97928c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#89837c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#847e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#75706a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5c5953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0a0203"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SafeSportLogo_PrimaryLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.62,130.4c-8.42,0-14.49-2-19.85-7.41l5.68-5.59c4.09,4.1,8.58,5.36,14.33,5.36,7.33,0,11.58-3.15,11.58-8.59a7.57,7.57,0,0,0-2.2-5.83c-1.42-1.34-2.84-1.89-6.15-2.36l-6.62-1c-4.56-.63-8.19-2.2-10.63-4.49-2.76-2.6-4.1-6.14-4.1-10.71,0-9.77,7.09-16.46,18.75-16.46,7.41,0,12.61,1.89,17.41,6.38l-5.43,5.35c-3.47-3.3-7.49-4.33-12.21-4.33-6.62,0-10.24,3.78-10.24,8.75a6.68,6.68,0,0,0,2.12,5.19,12.5,12.5,0,0,0,6.3,2.6l6.38,1c5.2.79,8.12,2,10.48,4.17,3.07,2.68,4.57,6.7,4.57,11.51C190.79,124.25,182.36,130.4,170.62,130.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.43,129.93l-3.86-11.27H208.44l-3.86,11.27h-9.06l20.56-56.09h6.85l20.56,56.09ZM219.7,86.52,211,111.41h17.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260,81.48V98.57h23.32v7.65H260v23.71h-8.5V73.84h35.84v7.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.53,129.93V73.84h35.84v7.64H306V97.86h23.31v7.57H306v16.86h27.33v7.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.78,130.4c-8.43,0-14.5-2-19.85-7.41l5.67-5.59c4.09,4.1,8.58,5.36,14.33,5.36,7.33,0,11.58-3.15,11.58-8.59a7.54,7.54,0,0,0-2.2-5.83c-1.42-1.34-2.84-1.89-6.15-2.36l-6.61-1c-4.57-.63-8.2-2.2-10.64-4.49-2.76-2.6-4.09-6.14-4.09-10.71,0-9.77,7.09-16.46,18.74-16.46,7.41,0,12.61,1.89,17.41,6.38l-5.43,5.35c-3.47-3.3-7.48-4.33-12.21-4.33-6.62,0-10.24,3.78-10.24,8.75a6.68,6.68,0,0,0,2.12,5.19,12.53,12.53,0,0,0,6.31,2.6l6.38,1c5.2.79,8.11,2,10.47,4.17,3.08,2.68,4.57,6.7,4.57,11.51C382.94,124.25,374.51,130.4,362.78,130.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.2,107.87H401.44v22.06h-8.5V73.84H414.2c10.95,0,18,7.25,18,17S425.15,107.87,414.2,107.87Zm-.47-26.39H401.44v18.67h12.29c5.91,0,9.93-3.39,9.93-9.3S419.64,81.48,413.73,81.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474,124.41a21.2,21.2,0,0,1-29.54,0c-5.51-5.51-5.43-11.74-5.43-22.53s-.08-17,5.43-22.53a21.23,21.23,0,0,1,29.54,0c5.52,5.52,5.36,11.74,5.36,22.53S479.5,118.9,474,124.41Zm-6.46-39.94a11.81,11.81,0,0,0-16.7,0c-2.76,3-3.31,6.15-3.31,17.41s.55,14.42,3.31,17.41a11.78,11.78,0,0,0,16.7,0c2.76-3,3.31-6.14,3.31-17.41S470.28,87.47,467.52,84.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.47,129.93l-11.82-23.64H499v23.64h-8.51V73.84h21.75c10.63,0,17.4,6.85,17.4,16.38,0,8-4.88,13.16-11.18,14.89l12.92,24.82Zm-9.85-48.45H499V99.05h12.6c5.68,0,9.54-3.23,9.54-8.75S517.3,81.48,511.62,81.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M559.67,81.48v48.45h-8.51V81.48H535.72V73.84H575.1v7.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.11,75.25V82h-1.58v-6.7h-2.12V73.84h5.82v1.41Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M592.27,82V77.22l-1.55,3.08h-1.07l-1.56-3.08V82h-1.58V73.84h1.56l2.12,4.38,2.11-4.38h1.56V82Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.68,46.69V32.31h5.54V46.55c0,4.09,2.05,6.22,5.43,6.22s5.42-2.05,5.42-6V32.31h5.54v14.2c0,7.62-4.28,11.36-11,11.36S154.68,54.1,154.68,46.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.39,51.72h5.82v5.75h-5.82Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.52,53.81l3.27-3.92A11.56,11.56,0,0,0,211.31,53c2.26,0,3.63-.9,3.63-2.38V50.5c0-1.4-.87-2.12-5.07-3.2-5.07-1.29-8.34-2.7-8.34-7.69v-.07c0-4.57,3.66-7.59,8.81-7.59a14.55,14.55,0,0,1,9.34,3.2l-2.87,4.17a11.8,11.8,0,0,0-6.55-2.48c-2.12,0-3.23,1-3.23,2.19v.07c0,1.66,1.08,2.2,5.43,3.31,5.1,1.33,8,3.17,8,7.55V50c0,5-3.81,7.8-9.24,7.8A16,16,0,0,1,200.52,53.81Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227,51.72h5.82v5.75H227Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.07,45v-.07a12.79,12.79,0,0,1,13.12-13,13,13,0,0,1,9.92,3.88l-3.52,4.06A9.3,9.3,0,0,0,267.15,37c-4.24,0-7.29,3.53-7.29,7.84v.07c0,4.32,3,7.91,7.29,7.91,2.88,0,4.64-1.15,6.62-2.95l3.52,3.56A12.86,12.86,0,0,1,267,57.91,12.71,12.71,0,0,1,254.07,45Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.92,32.31h19v4.93H299.42v5.1h11.87v4.93H299.42v5.28h13.66v4.92H293.92Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330.22,32.31h5.1L347.11,47.8V32.31h5.47V57.47h-4.71l-12.19-16v16h-5.46Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.36,37.42h-7.65V32.31h20.85v5.11H380.9v20h-5.54Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.94,32.31h19v4.93H408.44v5.1H420.3v4.93H408.44v5.28H422.1v4.92H402.94Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.61,32.31h11.5c3.2,0,5.68.9,7.34,2.55a7.9,7.9,0,0,1,2.15,5.75v.08a7.82,7.82,0,0,1-5.39,7.8l6.15,9h-6.47l-5.4-8h-4.35v8h-5.53Zm11.14,12.22c2.7,0,4.24-1.44,4.24-3.56V40.9c0-2.37-1.65-3.59-4.35-3.59h-5.5v7.22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485,32.31h19.16v5H490.49V42.7h12v5h-12v9.74H485Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M514.61,45v-.07a13,13,0,0,1,13.41-13c7.76,0,13.33,5.79,13.33,12.94v.07a13,13,0,0,1-13.4,13C520.18,57.91,514.61,52.12,514.61,45Zm21,0v-.07A7.65,7.65,0,0,0,528,37a7.53,7.53,0,0,0-7.55,7.84v.07A7.64,7.64,0,0,0,528,52.8,7.53,7.53,0,0,0,535.57,45Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M551.53,32.31H563c3.19,0,5.67.9,7.33,2.55a7.91,7.91,0,0,1,2.16,5.75v.08a7.82,7.82,0,0,1-5.4,7.8l6.15,9h-6.47l-5.39-8h-4.35v8h-5.54Zm11.14,12.22c2.7,0,4.25-1.44,4.25-3.56V40.9c0-2.37-1.66-3.59-4.35-3.59h-5.5v7.22Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.81,27.56A69.25,69.25,0,0,0,62,22.75C27.87,33.25,15.39,57.5,18.25,75.59c2,12.9,12.79,26.9,36.85,27.48h1c4.54,0,8.2-.79,10.59-2.29a6,6,0,0,0,3.15-5,5.27,5.27,0,0,0-1.69-3.86,5.84,5.84,0,0,0-4.32-1.55c-1.17.07-2.42.12-3.67.11h0C47,90.45,37.07,86.69,33,80.14c-4.52-7.28-3.65-18.47,2.15-27.84a51,51,0,0,1,20-17.91,67.8,67.8,0,0,1,32.57-7.74c8.15,0,18.82,1.86,26.1,3.59a1.42,1.42,0,0,0,1.68-.89A1.46,1.46,0,0,0,114.81,27.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120,83.18c-2-12.9-12.79-26.89-36.85-27.48-5.08-.13-9,.67-11.61,2.29a6,6,0,0,0-3.16,5,5.27,5.27,0,0,0,1.69,3.86,5.86,5.86,0,0,0,4.33,1.55c1.16-.06,2.41-.12,3.66-.1h0c13.22,0,23.12,3.75,27.18,10.3,4.52,7.29,3.65,18.48-2.15,27.85a51,51,0,0,1-20,17.9,67.78,67.78,0,0,1-32.57,7.74c-8.16,0-18.85-1.86-26.13-3.6a1.43,1.43,0,0,0-1,2.67A69.23,69.23,0,0,0,76.21,136C110.37,125.52,122.85,101.27,120,83.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeSportLogoPrimaryLogo);
export default __webpack_public_path__ + "static/media/SafeSportLogo_PrimaryLogo.2a6612db1447af59395076e7b74f0961.svg";
export { ForwardRef as ReactComponent };